export const timeFormat = "HH:mm";

export const currentUserData = JSON.parse(sessionStorage.getItem("userData"));

export const dayjsLocaleTj = {
  name: "tg",
  weekdays: [
    "якшанбе",
    "душанбе",
    "сешанбе",
    "чоршанбе",
    "панҷшанбе",
    "ҷумъа",
    "шанбе",
  ],
  weekdaysShort: ["Якш", "Дшб", "Сшб", "Чшб", "Пшб", "Ҷум", "Шнб"],
  weekdaysMin: ["Яш", "Дш", "Сш", "Чш", "Пш", "Ҷм", "Шн"],
  months: [
    "январ",
    "феврал",
    "март",
    "апрел",
    "май",
    "июн",
    "июл",
    "август",
    "сентябр",
    "октябр",
    "ноябр",
    "декабр",
  ],
  monthsShort: [
    "янв",
    "фев",
    "мар",
    "апр",
    "май",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ной",
    "дек",
  ],
  weekStart: 1,
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD.MM.YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm",
  },
  relativeTime: {
    future: "баъди %s",
    past: "%s пеш",
    s: "якчанд сония",
    m: "як дақиқа",
    mm: "%d дақиқа",
    h: "як соат",
    hh: "%d соат",
    d: "як рӯз",
    dd: "%d рӯз",
    M: "як моҳ",
    MM: "%d моҳ",
    y: "як сол",
    yy: "%d сол",
  },
};

export const roles = {
  1: {
    key: "admin",
    name: "Маъмур",
    mobiNavbarLinks: {
      "": [
        {
          id: 1,
          selectId: 1,
          name: "Кормандон",
          link: "/",
        },
        // {
        //   id: 2,
        //   selectId: 2,
        //   name: "Омӯзгорон",
        //   link: "/staffs/teachers",
        // },
        {
          id: 2,
          selectId: 2,
          name: "Бойгонӣ",
          link: "/archive",
        },
      ],

      periods: [
        {
          id: 1,
          selectId: 1,
          name: "Соли хониш",
          link: "/periods",
        },
        {
          id: 2,
          selectId: 2,
          name: "Семестерҳо",
          link: "/periods/semesters",
        },
        {
          id: 3,
          selectId: 3,
          name: "Бастҳо",
          link: "/periods/shifts",
        },
      ],

      groups: [
        { id: 1, selectId: 1, name: "Утоқи дарсӣ", link: "/groups" },

        { id: 2, selectId: 2, name: "Фан", link: "/groups/subject" },
        { id: 3, selectId: 3, name: "Гуруҳҳо", link: "/groups/editGroup" },
        { id: 4, selectId: 4, name: "Бойгонӣ", link: "/groups/archive" },
        { id: 5, selectId: 5, name: "Гузариш", link: "/groups/transition" },
      ],

      reference: [
        {
          id: 1,
          selectId: 1,
          name: "Навъи дарс",
          link: "/reference",
        },
        {
          id: 2,
          selectId: 2,
          name: "Навъи фан",
          link: "/reference/subjectNames",
        },
        {
          id: 3,
          selectId: 3,
          name: "Фанҳо",
          link: "/reference/subjects",
        },
        {
          id: 4,
          selectId: 4,
          name: "Вазифаҳо",
          link: "/reference/positions",
        },

        {
          id: 5,
          selectId: 5,
          name: "Миллат",
          link: "/reference/nationality",
        },

        {
          id: 6,
          selectId: 6,
          name: "Ихтисос",
          link: "/reference/speciality",
        },

        {
          id: 7,
          selectId: 7,
          name: "Маълумот",
          link: "/reference/educationRank",
        },

        {
          id: 8,
          selectId: 8,
          name: "Шаҳру ноҳияҳо",
          link: "/reference/cities",
        },

        {
          id: 9,
          selectId: 9,
          name: "Ихтисосҳои таълимӣ",
          link: "/reference/educationSpeciality",
        },

        {
          id: 10,
          selectId: 10,
          name: "Навъи кабинет",
          link: "/reference/cabinetType",
        },

        {
          id: 11,
          selectId: 11,
          name: "Кафедраҳо",
          link: "/reference/cafedra",
        },
      ],

      statistic: [
        {
          id: 1,
          selectId: 1,
          name: "Хисобот 1",
          link: "/statistic",
        },
        {
          id: 2,
          selectId: 2,
          name: "Хисобот 2",
          link: "/statistic/coursesAgesInfo",
        },
        {
          id: 3,
          selectId: 3,
          name: "Хисобот 3",
          link: "/statistic/coursesInfoBySpec",
        },

        {
          id: 4,
          selectId: 4,
          name: "Хисобот 4",
          link: "/statistic/coursesInfoByRegion",
        },

        {
          id: 5,
          selectId: 5,
          name: "Хисобот 5",
          link: "/statistic/collegeGraduates",
        },
        {
          id: 6,
          selectId: 6,
          name: "Хисобот 6",
          link: "/statistic/directorsInfo",
        },
        {
          id: 7,
          selectId: 7,
          name: "Хисобот 7",
          link: "/statistic/cafedrasInfo",
        },
        // {
        //   id: 8,
        //   selectId: 8,
        //   name: "Хисобот 8",
        //   link: "/statistic/attendanceInSemester",
        // },
        // {
        //   id: 8,
        //   selectId: 8,
        //   name: "Хисобот 8",
        //   link: "/statistic/coursesByLanguage",
        // },
        {
          id: 8,
          selectId: 8,
          name: "Хисобот 8",
          link: "/statistic/graduateCoursesBySpecReport",
        },
        {
          id: 9,
          selectId: 9,
          name: "Хисобот 9",
          link: "/statistic/graduateCoursesInfoByLanguage",
        },
        {
          id: 10,
          selectId: 10,
          name: "Хисобот 10",
          link: "/statistic/educationQualityInSemesters",
        },
        {
          id: 11,
          selectId: 11,
          name: "Хисобот 11",
          link: "/statistic/coursesAttendenceInSemesters",
        },
      ],
    },
  },
  2: {
    key: "teacher",
    name: "Омӯзгор",
    mobiNavbarLinks: {
      "": [
        {
          id: 1,
          selectId: 1,
          name: "Ҷадвали дарсии ман",
          link: "/",
        },
      ],
      myGroup: [
        {
          id: 1,
          selectId: 1,
          name: "Рӯзномаҳо",
          link: "/myGroup",
        },
        {
          id: 2,
          selectId: 2,
          name: "Давомот",
          link: "/myGroup/attendance",
        },

        // {
        //   id: 3,
        //   selectId: 3,
        //   name: "Фаъолияти волидайн",
        //   link: "/myGroup/parentActivity",
        // },

        {
          id: 3,
          selectId: 3,
          name: "Рейтинг",
          link: "/myGroup/rating",
        },
      ],
    },
  },
  3: {
    key: "curator",
    name: "Куратор",
    mobiNavbarLinks: {
      "": [
        {
          id: 1,
          selectId: 1,
          name: "Ҷадвали дарсии ман",
          link: "/",
        },
      ],
      myGroup: [
        {
          id: 1,
          selectId: 1,
          name: "Рӯзномаҳо",
          link: "/myGroup",
        },
        {
          id: 2,
          selectId: 2,
          name: "Давомот",
          link: "/myGroup/attendance",
        },

        {
          id: 3,
          selectId: 3,
          name: "Фаъолияти волидайн",
          link: "/myGroup/parentActivity",
        },

        {
          id: 4,
          selectId: 4,
          name: "Рейтинг",
          link: "/myGroup/rating",
        },
      ],
    },
  },
  4: {
    key: "parent",
    name: "Волидайн",
    mobiNavbarLinks: {
      "": [
        {
          id: 1,
          selectId: 1,
          name: "Баҳо",
          link: "/",
        },
      ],
      child: [
        {
          id: 1,
          selectId: 1,
          name: "Баҳо",
          link: "/child",
        },
        {
          id: 2,
          selectId: 2,
          name: "Ҷадвали дарсӣ",
          link: "/child/schedule",
        },

        {
          id: 3,
          selectId: 3,
          name: "Давомот",
          link: "/child/attendance",
        },

        {
          id: 4,
          selectId: 4,
          name: "Назорат",
          link: "/child/control",
        },
      ],
    },
  },
  5: {
    key: "student",
    name: "Донишҷӯ",
  },
  6: {
    key: "director",
    name: "Сардори коллеҷ",
    mobiNavbarLinks: {
      "": [
        {
          id: 1,
          selectId: 1,
          name: "Назорат",
          link: "/",
        },
        {
          id: 2,
          selectId: 2,
          name: "Ҷадвал",
          link: "/schedule",
        },
        {
          id: 3,
          selectId: 3,
          name: "Фан",
          link: "/subject",
        },
        {
          id: 4,
          selectId: 4,
          name: "Парванда",
          link: "/doc",
        },
        // {
        //   id: 5,
        //   selectId: 5,
        //   name: "Бойгонӣ",
        //   link: "/archive",
        // },
      ],
      periods: [
        {
          id: 1,
          selectId: 1,
          name: "Семестрҳо",
          link: "/periods",
        },
        {
          id: 2,
          selectId: 2,
          name: "Бастҳо",
          link: "/periods/shifts",
        },
      ],

      groups: [
        {
          id: 1,
          selectId: 1,
          name: "Утоқи дарсӣ",
          link: "/groups",
        },
        {
          id: 2,
          selectId: 2,
          name: "Таҳрири гуруҳ",
          link: "/groups/editGroup",
        },
        {
          id: 3,
          selectId: 3,
          name: "Хонандагон",
          link: "/groups/students",
        },
        // {
        //   id: 4,
        //   selectId: 4,
        //   name: "Бойгонӣ",
        //   link: "/groups/archive",
        // },
      ],

      statistic: [
        {
          id: 1,
          selectId: 1,
          name: "Хисобот 1",
          link: "/statistic",
        },
        {
          id: 2,
          selectId: 2,
          name: "Хисобот 2",
          link: "/statistic/coursesAgesInfo",
        },

        {
          id: 3,
          selectId: 3,
          name: "Хисобот 3",
          link: "/statistic/coursesInfoBySpec",
        },
        {
          id: 4,
          selectId: 4,
          name: "Хисобот 4",
          link: "/statistic/coursesInfoByRegion",
        },
        {
          id: 5,
          selectId: 5,
          name: "Хисобот 5",
          link: "/statistic/collegeGraduates",
        },
        {
          id: 6,
          selectId: 6,
          name: "Хисобот 6",
          link: "/statistic/directorsInfo",
        },
        {
          id: 7,
          selectId: 7,
          name: "Хисобот 7",
          link: "/statistic/cafedrasInfo",
        },
        // {
        //   id: 8,
        //   selectId: 8,
        //   name: "Хисобот 8",
        //   link: "/statistic/attendanceInSemester",
        // },
        {
          id: 8,
          selectId: 8,
          name: "Хисобот 8",
          link: "/statistic/coursesByLanguage",
        },

        {
          id: 9,
          selectId: 9,
          name: "Хисобот 9",
          link: "/statistic/educationQualityInSemesters",
        },
        {
          id: 10,
          selectId: 10,
          name: "Хисобот 10",
          link: "/statistic/coursesAttendenceInSemesters",
        },
        {
          id: 11,
          selectId: 11,
          name: "Хисобот 11",
          link: "/statistic/graduateCoursesBySpecReport",
        },
        // {
        //   id: 13,
        //   selectId: 13,
        //   name: "Хисобот 13",
        //   link: "/statistic/graduateCoursesInfoByLanguage",
        // },
      ],
    },
  },
  7: {
    key: "headTeacher",
    name: "Саромӯзгор оид ба илм",
    mobiNavbarLinks: {
      "": [
        {
          id: 1,
          selectId: 1,
          name: "Назорат",
          link: "/",
        },
        {
          id: 2,
          selectId: 2,
          name: "Ҷадвал",
          link: "/schedule",
        },
        {
          id: 3,
          selectId: 3,
          name: "Фан",
          link: "/subject",
        },
        {
          id: 4,
          selectId: 4,
          name: "Парванда",
          link: "/doc",
        },
        // {
        //   id: 5,
        //   selectId: 5,
        //   name: "Бойгонӣ",
        //   link: "/archive",
        // },
      ],
      periods: [
        {
          id: 1,
          selectId: 1,
          name: "Семестрҳо",
          link: "/periods",
        },
        {
          id: 2,
          selectId: 2,
          name: "Бастҳо",
          link: "/periods/shifts",
        },
      ],

      groups: [
        {
          id: 1,
          selectId: 1,
          name: "Утоқи дарсӣ",
          link: "/groups",
        },
        {
          id: 2,
          selectId: 2,
          name: "Таҳрири гуруҳ",
          link: "/groups/editGroup",
        },
        {
          id: 3,
          selectId: 3,
          name: "Хонандагон",
          link: "/groups/students",
        },
        // {
        //   id: 4,
        //   selectId: 4,
        //   name: "Бойгонӣ",
        //   link: "/groups/archive",
        // },
      ],

      statistic: [
        {
          id: 1,
          selectId: 1,
          name: "Хисобот 1",
          link: "/statistic",
        },
        {
          id: 2,
          selectId: 2,
          name: "Хисобот 2",
          link: "/statistic/coursesAgesInfo",
        },
        {
          id: 3,
          selectId: 3,
          name: "Хисобот 3",
          link: "/statistic/coursesInfoBySpec",
        },
        {
          id: 4,
          selectId: 4,
          name: "Хисобот 4",
          link: "/statistic/coursesInfoByRegion",
        },
        {
          id: 5,
          selectId: 5,
          name: "Хисобот 5",
          link: "/statistic/collegeGraduates",
        },
        {
          id: 6,
          selectId: 6,
          name: "Хисобот 6",
          link: "/statistic/directorsInfo",
        },
        {
          id: 7,
          selectId: 7,
          name: "Хисобот 7",
          link: "/statistic/cafedrasInfo",
        },
        {
          id: 8,
          selectId: 8,
          name: "Хисобот 8",
          link: "/statistic/attendanceInSemester",
        },
        {
          id: 9,
          selectId: 9,
          name: "Хисобот 9",
          link: "/statistic/coursesByLanguage",
        },

        {
          id: 10,
          selectId: 10,
          name: "Хисобот 10",
          link: "/statistic/educationQualityInSemesters",
        },
        {
          id: 11,
          selectId: 11,
          name: "Хисобот 11",
          link: "/statistic/coursesAttendenceInSemesters",
        },
        {
          id: 12,
          selectId: 12,
          name: "Хисобот 12",
          link: "/statistic/graduateCoursesBySpecReport",
        },
        {
          id: 13,
          selectId: 13,
          name: "Хисобот 13",
          link: "/statistic/graduateCoursesInfoByLanguage",
        },
      ],
    },
  },
  8: {
    key: "groupHead",
    name: "Сардори гуруҳ",
    mobiNavbarLinks: {
      // "": [
      //   {
      //     id: 1,
      //     selectId: 1,
      //     name: "Ҷадвали дарсии ман",
      //     link: "/",
      //   },
      // ],
      myGroup: [
        {
          id: 1,
          selectId: 1,
          name: "Рӯзномаҳо",
          link: "/myGroup",
        },
        {
          id: 2,
          selectId: 2,
          name: "Давомот",
          link: "/myGroup/attendance",
        },

        {
          id: 3,
          selectId: 3,
          name: "Фаъолияти волидайн",
          link: "/myGroup/parentActivity",
        },

        {
          id: 4,
          selectId: 4,
          name: "Рейтинг",
          link: "/myGroup/rating",
        },
      ],
    },
  },
};

export const navLinkItems = {
  admin: [
    {
      id: 1,
      name: "Кормандон",
      path: "/",
      end: false,
    },

    {
      id: 2,
      name: "Давраҳо",
      path: "periods",
      end: false,
    },

    {
      id: 3,
      name: "Гуруҳҳо",
      path: "groups",
      end: false,
    },

    {
      id: 4,
      name: "КоллеҶ",
      path: "aboutInfo",
      end: false,
    },

    {
      id: 4,
      name: "маълумотнома",
      path: "reference",
      end: false,
    },

    {
      id: 5,
      name: "Омор",
      path: "statistic",
      end: false,
    },
  ],

  teacher: [
    {
      id: 1,
      name: "Ҷадвали дарсӣ",
      path: "",
      end: true,
    },
    {
      id: 2,
      name: "Журнал",
      path: "journal",
      end: false,
    },
    {
      id: 3,
      name: "гуруҳи ман",
      path: "myGroup",
      end: false,
    },
  ],
  curator: [
    {
      id: 1,
      name: "Ҷадвали дарсӣ",
      path: "",
      end: true,
    },
    {
      id: 2,
      name: "Журнал",
      path: "journal",
      end: false,
    },
    {
      id: 3,
      name: "гуруҳи ман",
      path: "myGroup",
      end: false,
    },
  ],

  director: [
    {
      id: 1,
      name: "Кормандон",
      path: "",
      end: true,
    },
    {
      id: 2,
      name: "Давраҳо",
      path: "periods",
      end: false,
    },
    {
      id: 3,
      name: "Гуруҳҳо",
      path: "groups",
      end: false,
    },
    {
      id: 4,
      name: "Омор",
      path: "statistic",
      end: false,
    },
  ],

  headTeacher: [
    {
      id: 1,
      name: "Кормандон",
      path: "",
      end: true,
    },
    {
      id: 2,
      name: "Давраҳо",
      path: "periods",
      end: false,
    },
    {
      id: 3,
      name: "Гуруҳҳо",
      path: "groups",
      end: false,
    },
    {
      id: 4,
      name: "Омор",
      path: "statistic",
      end: false,
    },
  ],

  parent: [
    {
      id: 1,
      name: "Маълумотнома",
      path: "",
    },
  ],
  groupHead: [
    {
      id: 1,
      name: "Ҷадвали дарсӣ",
      path: "",
      end: true,
    },
    {
      id: 2,
      name: "Журнал",
      path: "journal",
      end: false,
    },
    {
      id: 3,
      name: "гуруҳи ман",
      path: "myGroup",
      end: false,
    },
  ],
};
